import React from 'react'

export const Header = () => {
  return (
    <div className="header">
      <h1>Chit-Chat</h1>
    </div>
  )
}


